<template>
	<footer class="bd-footerarea-1">
		<div class="container bd-containereffect-31">
			<div class="bd-layoutbox-26">
				<div class="bd-container-inner"></div>
			</div>
			<div class="bd-container-sitemap">
				<p class="ma-2 text-h5 sitemap">Sitemap</p>
				<v-row row-wrap cols="12">
					<v-col cols="2">
						<router-link class="ml-2 mr-1 caption" to="/unternehmen">Unternehmen</router-link>
					</v-col>
					<v-col cols="2">
						<router-link class="ml-2 mr-1 caption" to="/angebote">Leistungsangebote</router-link>
					</v-col>
					<v-col cols="2">
						<router-link class="ml-2 mr-1 caption" to ="/career">Karriere</router-link>
					</v-col>
					<v-col cols="2">
						<router-link class="ml-2 mr-1 caption" to="/impressum">Impressum</router-link>
					</v-col>
				</v-row>
				<v-row row-wrap cols="12">
					<v-col cols="6">
						<router-link class="ml-2 mr-1 caption" to="/arbeiten-bei-manitz-it">Arbeiten bei MANITZ IT</router-link>
					</v-col>
					<v-col cols="2">
						<router-link class="ml-2 mr-1 caption" to="/datenschutz">Datenschutz</router-link>
					</v-col>
				</v-row>
			</div>
			<div class="bd-container-copy">
				<div class="">&copy; 2015 - 2020, MANITZ IT</div>
			</div>
		</div>
	</footer>
</template>

<script>
	export default {
		name: "MainFooter"
	}
</script>

<style scoped>
footer {
	display: block;
}

footer a {
	color: white;
	text-decoration: none;
}

.sitemap {
	color: white;
}

footer a:hover {
	text-decoration: underline;
}
.bd-layoutbox-26 {
    background-attachment: scroll;
    height: 200px;
    text-align: center;
    margin-top: 0;
}
.bd-layoutbox-26 {
	background-image: url(../../assets/white2.png) !important;
	background-size: 100% auto;
}
.bd-containereffect-31 {
	padding: 0;
	margin: 0;
    background-color: #fa7b05;
}
.bd-container-sitemap {
	padding: 0px 0px 1.5em 0.5em;
	vertical-align: bottom;
	font-size: 0.8em;
	color: white;
}
.bd-container-copy {
	padding: 0px 0px 0.5em 1em;
	vertical-align: bottom;
	font-size: 0.8em;
	color: white;
}

.bd-container-sitemap .col.col-2,
.bd-container-sitemap .col.col-6 {
	padding: 0px 12px;
}
</style>
